export default __webpack_public_path__ + "static/media/upload.49e98e71.webp";